import type { IDenovoIconProps, IconName } from "./interfaces";

import { ICON_ALIASES } from "./alias-map";
import { CUSTOM_ICON_COMPONENTS } from "./_custom";
import { MATERIAL_ICON_SVGS } from "./_generated/icon-map.generated";

export type { IconName };

const DEFAULT_SIZE = 24;

const RTL_MIRRORED_ICONS = new Set([
  "arrow_back",
  "arrow_forward",
  "arrow_circle_left",
  "arrow_circle_right",
  "chevron_left",
  "chevron_right",
  "logout",
  "login",
]);

export const DenovoIcon = (props: IDenovoIconProps) => {
  const {
    icon,
    width,
    height,
    size,
    color,
    className,
    expanded,
    direction,
    strokeWidth,
    ...rest
  } = props;

  const CustomIcon = CUSTOM_ICON_COMPONENTS[icon];
  if (CustomIcon) {
    return (
      <CustomIcon
        data-testid={icon}
        width={width ?? size}
        height={height ?? size}
        color={color}
        expanded={expanded}
        className={className}
      />
    );
  }

  const materialName = ICON_ALIASES[icon] ?? icon;
  const inner = MATERIAL_ICON_SVGS[materialName];

  if (inner) {
    const dimension = width ?? size ?? DEFAULT_SIZE;
    const mirrorClass = RTL_MIRRORED_ICONS.has(materialName)
      ? "rtl:-scale-x-100"
      : undefined;
    return (
      <svg
        data-testid={icon}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width={dimension}
        height={height ?? size ?? dimension}
        fill="currentColor"
        aria-hidden={true}
        className={
          mirrorClass
            ? `${mirrorClass}${className ? ` ${className}` : ""}`
            : className
        }
        style={color ? { color } : undefined}
        dangerouslySetInnerHTML={{ __html: inner }}
        {...rest}
      />
    );
  }

  const fallbackSize = width ?? size ?? DEFAULT_SIZE;
  return (
    <span
      data-testid={icon}
      aria-hidden={true}
      className={className}
      style={{
        display: "inline-block",
        width: fallbackSize,
        height: height ?? size ?? fallbackSize,
        border: "1px dashed currentColor",
        borderRadius: 2,
        opacity: 0.4,
      }}
    />
  );
};
